import React from "react";

import JumboLayout from "@jumbo/components/JumboLayout";
import { useJumboApp } from "@jumbo/hooks";
import { LAYOUT_NAMES } from "../../../layouts/layouts";
import InformacionPersonalCliente from "./InformacionCliente/InformacionPersonalCliente";

const ClienteInformacion = () => {
  const { setActiveLayout } = useJumboApp();

  React.useEffect(() => {
    setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);
  return (
    <>
      <h2 className="titulosPrincipales-container">Cliente - Información </h2>
      <InformacionPersonalCliente />
    </>
  );
};

export default ClienteInformacion;
